import { gql, useQuery } from '@apollo/client';
import { useShareTokenJwt } from '@app/hooks/useShareTokenJwt';

const AVAILABLE_SERVICES_FOR_CATEGORY = gql`
  query AvailableServicesForCategory($category: String!, $token: String) {
    availableServicesForCategory(category: $category, token: $token) {
      id
      serviceName
      approved
    }
  }
`;

export interface ServiceOption {
  id: string;
  serviceName: string;
  approved: boolean;
}

export interface AvailableServicesForCategoryData {
  availableServicesForCategory: ServiceOption[];
}

export interface AvailableServicesForCategoryVariables {
  category: string;
  token?: string | null;
}

export function useAvailableServicesForCategoryQuery(category: string | null | undefined) {
  const { token, waitingForShareToken } = useShareTokenJwt();
  console.log('TOKEN', token);
  return useQuery<AvailableServicesForCategoryData, AvailableServicesForCategoryVariables>(
    AVAILABLE_SERVICES_FOR_CATEGORY,
    {
      variables: { category: category ?? '', token },
      skip: !category || waitingForShareToken,
      fetchPolicy: 'cache-first',
    }
  );
}
